// extracted by mini-css-extract-plugin
export var cartIcon = "_hi-0";
export var cartIconContainer = "_hi-1";